import {
  ENABLE_SHIPPING_ADDRESS_MODAL,
  DISABLE_SHIPPING_ADDRESS_MODAL,
  ENABLE_CREDIT_CARD_INFO_MODAL,
  DISABLE_CREDIT_CARD_INFO_MODAL,
  ENABLE_CREDIT_CARD_LIST,
  DISABLE_CREDIT_CARD_LIST,
} from '../actions/modals/types';

const initState = {
  shippingAddress: false,
  creditCardInfo: false,
  creditCardList: false,
};

const modals = (state = initState, action) => {
  switch (action.type) {
    case ENABLE_SHIPPING_ADDRESS_MODAL:
      return {
        shippingAddress: true,
        creditCardInfo: false,
        creditCardList: false,
      };
    case DISABLE_SHIPPING_ADDRESS_MODAL:
      return {
        ...state,
        shippingAddress: false,
      };
    case ENABLE_CREDIT_CARD_INFO_MODAL:
      return {
        shippingAddress: false,
        creditCardInfo: true,
        creditCardList: false,
      };
    case DISABLE_CREDIT_CARD_INFO_MODAL:
      return {
        ...state,
        creditCardInfo: false,
      };
    case ENABLE_CREDIT_CARD_LIST:
      return {
        shippingAddress: false,
        creditCardInfo: false,
        creditCardList: true,
      };
    case DISABLE_CREDIT_CARD_LIST:
      return {
        ...state,
        creditCardList: false,
      };
    default:
      return state;
  }
};

export default modals;



// WEBPACK FOOTER //
// ./src/reducers/modals.js